<script>
import Endpoints from '../../../components/common/Endpoints';


export default {


    init: async(payload) => {
            payload.domain = Endpoints.domain;

      
    },

    methods:{
      
    }
 
}
</script>
